import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";

const IntlMessage = (props) => {
	const { id, ...rest } = props;
	const resolvedId =
		typeof id === "string"
			? id
			: id != null && typeof id === "object" && typeof id.id === "string"
				? id.id
				: undefined;
	if (resolvedId === undefined) {
		if (id != null && !React.isValidElement(id))
			return props.defaultMessage ?? String(id);
		return null;
	}
	return (
		<FormattedMessage
			{...rest}
			id={resolvedId}
			defaultMessage={
				rest.defaultMessage ??
				(id != null && typeof id === "object" ? id.defaultMessage : undefined)
			}
		/>
	);
};
export default injectIntl(IntlMessage, {
	withRef: false,
});
